"use client";

import React, { Suspense, useEffect, useState } from "react";
import "./globals.css";

import { MedicalScreening } from "medical-screening-lib";
import {
  checkGetHelpButtonStatus,
  domainHeaderVerisk,
  DomainKey,
  domainVerisk,
} from "@/utils/medical-screen.utils";
import { DOMAIN_KEY, VERISK_KEY, VERISK_URL } from "@/constants";

export default function Home() {
  const [isClient, setIsClient] = useState(false);
  const [hashCode, setHashCode] = useState<string | null>(null);
  const [travellerName, setTravellerName] = useState<string | null>(null);
  const [domain, setDomain] = useState<string>("");
  const [operationFlow, setOperationFlow] = useState<string>("");
  const [businessFlow, setBusinessFlow] = useState<string>("");
  const [styleLoadState, setStyleLoadState] = useState<boolean>(false);

  const [brand, setBrand] = useState<string>("");

  function setDynamicFonts(primaryFont: string, secondaryFont: string) {
    const root = document.documentElement;
    // Set CSS variables dynamically
    root.style.setProperty("--font-primary", primaryFont);
    root.style.setProperty("--font-secondary", secondaryFont);
  }

  useEffect(() => {
    setIsClient(true);
    // if (typeof window !== "undefined") {
    //   window.onload = function () {
    //     const height = document.body.scrollHeight; // Get the iframe content height
    //     const width = document.body.scrollWidth; // Optionally get the content width
    //     window.parent.postMessage({ height: 1500, width }, "*");
    //   };
    // }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const travellerName = urlParams.get("name");
    setTravellerName(travellerName || "Traveller");
    const hash = urlParams.get("hash");
    setHashCode(hash);
    const domain = urlParams.get("domain");
    const operationFlow = urlParams.get("operation-flow");
    const businessFlow = urlParams.get("business-flow");

    const resolvedDomain = DOMAIN_KEY || domain || "STS";
    setDomain(resolvedDomain);

    const isAvanti = resolvedDomain === "AVN";
    setBrand(isAvanti ? "avanti" : "staysure");
    if (!isAvanti) {
      setStyleLoadState(true);
    } else {
      setTimeout(() => {
        setStyleLoadState(true);
      }, 1500);
    }

    setOperationFlow(operationFlow || "CREATE_FLOW");
    setBusinessFlow(businessFlow || "OFFLINE");
  }, []);

  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `/${brand}.css`; // Dynamically load based on brand
    link.id = `brand-stylesheet-${brand}`;
    document.head.appendChild(link);

    // Example usage:
    if (brand === "staysure") {
      setDynamicFonts(
        '"proxima-nova", "Helvetica", "Arial", "sans-serif"',
        '"DM Serif Display", "sans-serif"'
      );
    } else {
      setDynamicFonts(
        '"faktum", "Helvetica", "Arial", "sans-serif"',
        '"faktum", "sans-serif"'
      );
    }

    return () => {
      document.head.removeChild(link);
    };
  }, [brand]);

  useEffect(() => {
    if (domain) {
      // Update the page title
      document.title =
        domainHeaderVerisk[domain as DomainKey]?.title ||
        "Staysure™ Travel Insurance - It's Worth Doing Right";

      // Update the meta description
      const descriptionMetaTag = document.querySelector(
        'meta[name="description"]'
      );
      if (descriptionMetaTag) {
        descriptionMetaTag.setAttribute(
          "content",
          domainHeaderVerisk[domain as DomainKey]?.description ||
            "Staysure is the over 50s expert, offering a wide range of products and services including travel insurance, private medical, life insurance, and more."
        );
      }

      // Update the favicon
      let faviconLink = document.querySelector(
        "link[rel='icon']"
      ) as HTMLLinkElement | null;

      if (!faviconLink) {
        // Create and append the favicon link if it doesn't exist
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        document.head.appendChild(faviconLink);
      }
      if (faviconLink) {
        faviconLink.href =
          domainHeaderVerisk[domain as DomainKey]?.favicon || "/favicon.ico";
      }
    }
  }, [domain]);

  return (
    <Suspense>
      <div>
        {isClient && styleLoadState && (
          <MedicalScreening
            baseUrl={VERISK_URL}
            brand={domainVerisk[domain as DomainKey]?.v3 || "STS"}
            onComplete={function (
              hash?: string,
              complete?: boolean,
              returnUrl?: string
            ): void {
              if (complete && returnUrl) {
                window.open(`${returnUrl}`, "_self");
              } else if (complete) {
                alert("SucessfullyCompleted.......");
              }
            }}
            customerData={{
              name: travellerName || "",
              postCode: null,
              quoteOrigin: null,
              gender: null,
              tripDuration: null,
              leadTime: null,
            }}
            logoUrl={""}
            legacyToken={hashCode || ""}
            headerParams={{
              domain,
              operationFlow,
              businessFlow,
              xAPIKey: VERISK_KEY,
            }}
            isLeagacy={checkGetHelpButtonStatus(
              domain,
              businessFlow,
              operationFlow
            )}
          />
        )}
      </div>
    </Suspense>
  );

  // return <div>{typeof window !== "undefined" ? <MedicalScreening /> : <></>}</div>;
}
